<div class="tab-panel tab-panel--steps">
  <div class="detail-list">
    <div class="detail-row detail-row--step-table">
      <div class="detail-row__label">
        <div>
          <span>Step Table</span>
        </div>
      </div>
      <div class="detail-row__value">
        <div class="step-table-card">
          @if (!expanded) {
          <div class="step-table-summary" (click)="openTableDetails()">
            <app-test-summary-table [inputTableData]="tableData"></app-test-summary-table>
          </div>
          } @if (expanded && tableName && tableData) {
          <div class="step-table-body">
            <app-test-step-table
              [tableName]="tableName"
              [nodeData]="selectedNode"
              [inputTableData]="tableData"
              [inputTableConfig]="tableConfig"
              [projectName]="selectedProject?.name"
              [workspaceName]="selectedWorkspace?.name"
              [projectId]="selectedProject?.id || ''"
              [workspaceId]="selectedWorkspace?.id || ''"
              [tableIndex]="tableIndex"
              [attachmentsOrg]="attachmentsOrg"
              [isAutoNumberColumn]="isAutoNumberColumn"
              [readOnly]="readOnly"
              (outputTableDataEvent)="onTableDataOutput($event)"
              (tableEditEvent)="onTableEdit()"></app-test-step-table>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
